import { UserResponse, UserRoles } from '@/types/user';
import { titleCase } from '@/utils/stringCaser';
import { SVLink, SVSummaryCard } from '@/components/core';
import { SVSummaryCardItem } from '@/types/common';
import { Stack } from '@mui/material';
import { FORM_FIELDS } from '@/constants/formFields';
import TeammateLink from '@/components/TeammateLink';

type ProfileBasicAdvisorInfoProps = {
  user: UserResponse;
};

export default function ProfileBasicAdvisorInfo({
  user,
}: ProfileBasicAdvisorInfoProps) {
  const items: SVSummaryCardItem[] = [
    {
      label: FORM_FIELDS.FIRST_NAME.label,
      text: user.firstName,
    },
    {
      label: FORM_FIELDS.LAST_NAME.label,
      text: user.lastName,
    },
    {
      label: FORM_FIELDS.EMAIL.label,
      text: user.email,
    },
    {
      label: FORM_FIELDS.PHONE.label,
      text: user.phoneNumber,
    },
    {
      label: FORM_FIELDS.BUSINESS_PHONE.label,
      text: user.businessPhoneNumber,
    },
    {
      label: 'Role',
      text: titleCase(user.role.replace('_', ' ')),
    },
    {
      label: 'Title',
      text: user.title,
    },
    {
      label: FORM_FIELDS.COMPANY.label,
      text: user.teammateInfo?.company?.name,
    },
    {
      label:
        user.role === UserRoles.TEAMMATE_SUPPORTER
          ? 'Advisors'
          : 'Support Members',
      customContent: user.teammateInfo?.members.length ? (
        <Stack spacing={1}>
          {user.teammateInfo.members.map(member => (
            <TeammateLink
              key={member.uuid}
              uuid={member.uuid}
              name={`${member.fullName}`}
            />
          ))}
        </Stack>
      ) : null,
    },
    {
      label: 'Advisor URL',
      text: user.teammateInfo?.advisorUrl,
      customContent: (
        <SVLink target="_blank" to={user.teammateInfo?.advisorUrl || ''}>
          {user.teammateInfo?.advisorUrl}
        </SVLink>
      ),
    },
    {
      label: 'Bio',
      text: user.bio,
    },
  ];

  return (
    <SVSummaryCard label="Basic Info" items={items} avatar={user.avatarUrl} />
  );
}
